module.exports = __webpack_public_path__ + "static/media/project.aa7c25e9.svg";